import Compress from "browser-image-compression";

const maxFileSize = 3.0;

export const resizeImages = async (files: File[]) => {
  const options = {
    maxSizeMB: maxFileSize,
    useWebWorker: true
  };
  try {
    let bigFiles: File[] = [];
    let newList: File[] = [];
    files.map((item) =>
      item.size > maxFileSize * 1024 * 1024
        ? bigFiles.push(item)
        : newList.push(item)
    );

    if (bigFiles.length) {
      const payload: Promise<File>[] = bigFiles.map((item) =>
        Compress(item, options)
      );

      const responseCompressImg: PromiseSettledResult<File>[] =
        await Promise.allSettled(payload);

      responseCompressImg.map(
        (item) => item.status === "fulfilled" && newList.push(item.value)
      );
    }
    return newList;
  } catch (err) {
    console.log(err);
    return [];
  }
};
